import { createStore } from 'redux';
import reducers from './reducers';
import { persistStore } from "redux-persist";

const store = createStore(reducers)
const persister = persistStore(store);

export { store, persister };